<template>
  <div>
    <div class="text-lg font-bold mb-4">{{$t('main.landscaping')}}</div>

    <div
      v-for="landscaping in landscapings"
      :key="`cart-landscaping-order-${landscaping.element_id}`"
    >
      <div
        v-if="landscaping.position == 'mainElement'"
        class="text-xl mb-4"
      >
        <div class="element-item-list">
          <div class="element-item">
            <div class="element-group flex justify-between items-center mb-4">
              <div class="text-xl">{{$t('main.base')}}</div>
              <div
                v-if="
                        landscaping.total &&
                        settings.with_calc_price == 1"
                class="font-bold text-xl mt-2 text-right"
              >
                {{ $toCurrency(landscaping.total) }}
              </div>

            </div>
            <div class="element-detail flex justify-between">
              <div class="image">
                <div class="image-wrapper">
                  <div
                    class="image-src"
                    :style="{
                          backgroundImage: `url(${landscaping.thumb})`,
                        }"
                  ></div>
                </div>
              </div>
              <div class="detail w-full text-sm">
                <div class="flex justify-between">
                  <div>
                    <span class="font-bold">{{$t('main.name')}}: </span>
                    <span>{{ landscaping.name }}</span>
                  </div>
                  <div v-if="settings.with_calc_price == 1">
                  {{ $toCurrency(parseFloat(landscaping.size_price)) }}
                    <span v-if="
                            landscaping.group_slug ==
                              'plate-fill' ||
                            landscaping.group_slug ==
                              'stripe'
                          ">
                      /м<sup>3</sup>
                    </span>
                    <span v-if="
                            landscaping.group_slug ==
                              'paving' ||
                            landscaping.group_slug ==
                              'pour' ||
                            landscaping.group_slug ==
                              'grass'
                          ">
                      /м<sup>2</sup>
                    </span>
                  </div>
                </div>
                <div>
                  <span class="font-bold">{{$t('main.article')}}: </span>
                  <span>{{ landscaping.article }}</span>
                </div>
                <div>
                  <span class="font-bold">{{$t('client.complectation.sizes_sm')}}: </span>
                  <span v-if="landscaping.group_slug == 'paving'&&landscaping.fact_sizes">{{landscaping.fact_sizes}}</span>
                  <span v-else-if="
                          landscaping.group_slug ==
                            'plate-ready' ||
                          landscaping.group_slug == 'paving'
                        ">
                    {{ landscaping.width }} x
                    {{ landscaping.length }} x
                    {{ landscaping.height }}
                  </span>
                  <span v-if="
                          landscaping.group_slug ==
                            'plate-fill' ||
                          landscaping.group_slug == 'stripe'
                        ">{{ landscaping.width }} x
                    {{ landscaping.length }}</span>

                </div>
                <div v-if="
                        landscaping.group_slug ==
                          'plate-fill' ||
                        landscaping.group_slug == 'stripe'
                      ">
                  <span class="font-bold">{{$t('client.complectation.height_under_earth')}}: </span>
                  <span>{{ landscaping.height }}</span>
                </div>
                <div v-if="
                        landscaping.group_slug ==
                          'plate-fill' ||
                        landscaping.group_slug == 'stripe'
                      ">
                  <span class="font-bold">{{$t('client.complectation.deep_in_earth')}}: </span>
                  <span>{{ landscaping.depth }}</span>
                </div>
                <div v-if="
                        landscaping.group_slug == 'stripe'
                      ">
                  <span class="font-bold">{{$t('client.complectation.width_sm')}}: </span>
                  <span>{{ landscaping.thickness }}</span>
                </div>
                <div v-if="
                        landscaping.group_slug !=
                        'plate-ready'
                      ">
                  <span
                    class="font-bold"
                    v-html="$t('client.complectation.square')+':'"
                  >
                  </span>
                  <span>{{ landscaping.square.toFixed(2) }}</span>
                </div>
                <div v-if="
                        landscaping.group_slug ==
                          'plate-fill' ||
                        landscaping.group_slug == 'stripe'
                      ">
                  <span
                    class="font-bold"
                    v-html="$t('client.complectation.volume')+':'"
                  > </span>
                  <span>{{ landscaping.volume }}</span>
                </div>
                <div>
                  <span class="font-bold">{{$t('main.type')}}: </span>
                  <span>{{ landscaping.type }}</span>
                </div>
                <div
                  v-if="parseFloat(landscaping.base_price_preparation)"
                  class="flex justify-between"
                >
                  <span class="font-bold">{{$t('client.complectation.prepare_works')}}: </span>
                  <span>{{ $toCurrency(landscaping.base_price_preparation) }}/м<sup>2</sup></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="landscaping.position == 'facing_top'"
        class="text-xl mb-4 border-blue-top"
      >
        <div class="element-item-list">
          <div class="element-item">
            <div class="element-group flex justify-between items-center mb-4">
              <div class="text-xl">{{$t('main.facing_top')}}</div>
              <div
                v-if="
                        landscaping.total &&
                        settings.with_calc_price == 1
                      "
                class="font-bold text-xl mt-2 text-right"
              >
                {{ $toCurrency(landscaping.total) }}
              </div>
            </div>
            <div class="element-detail flex justify-between">
              <div class="image">
                <div class="image-wrapper">
                  <div
                    class="image-src"
                    :style="{
                          backgroundImage: `url(${landscaping.thumb})`,
                        }"
                  ></div>
                </div>
              </div>
              <div class="detail w-full pl-4 text-sm">
                <div class="flex justify-between">
                  <div>
                    <span class="font-bold">{{$t('main.name')}}: </span>
                    <span>{{ landscaping.name }}</span>
                  </div>
                  <div v-if="settings.with_calc_price == 1">
                    {{ $toCurrency(parseFloat(landscaping.size_price)) }}
                    /м<sup>2</sup>
                  </div>
                </div>
                <div>
                  <span class="font-bold">{{$t('main.article')}}: </span>
                  <span>{{ landscaping.article }}</span>
                </div>
                <div>
                  <span class="font-bold">{{$t('client.complectation.sizes_sm')}}: </span>

                  <span v-if="landscaping.fact_sizes">
                    {{ landscaping.fact_sizes }}
                  </span>

                  <span v-else>
                    {{ landscaping.width }} x
                    {{ landscaping.length }} x
                    {{ landscaping.height }}
                  </span>
                </div>
                <div>
                  <span
                    class="font-bold"
                  >
                    {{ $t('client.complectation.square') }}:
                  </span>
                  <span>{{ landscaping.square }}</span>
                </div>
                <div>
                  <span class="font-bold">{{$t('main.type')}}: </span>
                  <span>{{ landscaping.type }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="landscaping.position == 'facing_side'"
        class="text-xl mb-4 border-blue-top"
      >
        <div class="element-item-list">
          <div class="element-item">
            <div class="element-group flex justify-between items-center mb-4">
              <div class="text-xl">{{$t('main.facing_side')}}</div>
              <div
                v-if="
                        landscaping.total &&
                        settings.with_calc_price == 1"
                class="font-bold text-xl mt-2 text-right"
              >
                {{ $toCurrency(landscaping.total) }}
              </div>
            </div>
            <div class="element-detail flex">
              <div class="image">
                <div class="image-wrapper">
                  <div
                    class="image-src"
                    :style="{
                          backgroundImage: `url(${landscaping.thumb})`,
                        }"
                  ></div>
                </div>
              </div>
              <div class="detail w-full pl-4 text-sm">
                <div class="flex justify-between">
                  <div>
                    <span class="font-bold">{{$t('main.name')}}: </span>
                    <span>{{ landscaping.name }}</span>
                  </div>
                  <div v-if="settings.with_calc_price == 1">
                    {{ $toCurrency(parseFloat(landscaping.size_price)) }}
                    /м<sup>2</sup>
                  </div>
                </div>
                <div>
                  <span class="font-bold">{{$t('main.article')}}: </span>
                  <span>{{ landscaping.article }}</span>
                </div>
                <div>
                  <span class="font-bold">{{$t('client.complectation.sizes_sm')}}: </span>
                  <span v-if="landscaping.fact_sizes">
                    {{ landscaping.fact_sizes }}
                  </span>

                  <span v-else>
                    {{ landscaping.width }} x
                    {{ landscaping.length }} x
                    {{ landscaping.height }}
                  </span>
                </div>
                <div>
                  <span
                    class="font-bold"
                    v-html="$t('client.complectation.square')+': '"
                  >
                  </span>

                  <span>{{ landscaping.square }}</span>
                </div>
                <div>
                  <span class="font-bold">{{$t('main.type')}}: </span>
                  <span>{{ landscaping.type }}</span>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="landscaping.position == 'fillElement'"
        class="text-xl mb-4 border-blue-top"
      >
        <div class="element-item-list">
          <div class="element-item">
            <div class="element-group flex justify-between items-center mb-4">
              <div class="text-xl">{{$t('main.filling')}}</div>
              <div
                v-if="
                        landscaping.total &&
                        settings.with_calc_price == 1"
                class="font-bold text-xl mt-2 text-right"
              >
                {{ $toCurrency(landscaping.total) }}
              </div>
            </div>
            <div class="element-detail flex justify-between">
              <div class="image">
                <div class="image-wrapper">
                  <div
                    class="image-src"
                    :style="{
                          backgroundImage: `url(${landscaping.thumb})`,
                        }"
                  ></div>
                </div>
              </div>
              <div class="detail w-full pl-4 text-sm">
                <div class="flex justify-between">
                  <div>
                    <span class="font-bold">{{$t('main.name')}}: </span>
                    <span>{{ landscaping.name }}</span>
                  </div>
                  <div v-if="settings.with_calc_price == 1">
                    {{ $toCurrency(parseFloat(landscaping.size_price)) }}
                    /м<sup>2</sup>
                  </div>
                </div>
                <div>
                  <span class="font-bold">{{$t('main.article')}}: </span>
                  <span>{{ landscaping.article }}</span>
                </div>

                <div>
                  <span
                    class="font-bold"
                    v-html="$t('client.complectation.square')+': '"
                  >
                  </span>
                  <span>{{ landscaping.square.toFixed(2) }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="font-bold">{{$t('client.complectation.prepare_works')}}: </span>
                  <span>{{ $toCurrency(landscaping.base_price_preparation) }}/м<sup>2</sup></span>
                </div>
                <div>
                  <span class="font-bold">{{$t('main.type')}}: </span>
                  <span>{{ landscaping.type }}</span>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="landscaping.position == 'borderElement'"
        class="text-xl mb-4 border-blue-top"
      >
        <div class="element-item-list">
          <div class="element-item">
            <div class="element-group flex justify-between items-center mb-4">
              <div class="text-xl">{{$t('client.complectation.border')}}</div>
              <div
                v-if="
                    landscaping.total &&
                    settings.with_calc_price == 1"
                class="font-bold text-xl mt-2 text-right"
              >
                {{ $toCurrency(landscaping.total) }}
              </div>

            </div>
            <div class="element-detail flex justify-between">
              <div class="image">
                <div class="image-wrapper">
                  <div
                    class="image-src"
                    :style="{
                          backgroundImage: `url(${landscaping.thumb})`,
                        }"
                  ></div>
                </div>
              </div>
              <div class="detail w-full pl-4 text-sm">
                <div class="flex justify-between">
                  <div>
                    <span class="font-bold">{{$t('main.name')}}: </span>
                    <span>{{ landscaping.name }}</span>
                  </div>
                  <div v-if="settings.with_calc_price == 1">
                    {{ $toCurrency(parseFloat(landscaping.size_price)) }}
                    /{{$t('main.m_p')}}
                  </div>
                </div>
                <div>
                  <span class="font-bold">{{$t('main.article')}}: </span>
                  <span>{{ landscaping.article }}</span>
                </div>
                <div>
                  <span class="font-bold">{{$t('client.complectation.sizes_sm')}}: </span>
                  <span>
                    {{ landscaping.width }} x
                    {{ landscaping.length }} x
                    {{ landscaping.height }}
                  </span>
                </div>
                <div>
                  <span class="font-bold">{{$t('main.metraz')}}: </span>
                  <span>{{ landscaping.perimeter }}</span>
                </div>
                <div>
                  <span class="font-bold">{{$t('main.type')}}: </span>
                  <span>{{ landscaping.type }}</span>
                </div>
                <div class="flex justify-between">
                  <span class="font-bold">{{$t('client.complectation.prepare_works')}}: </span>
                  <span>{{ $toCurrency(landscaping.base_price_preparation) }}/{{$t('main.m_p')}}</span>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
export default {
  props: {
    landscapings: {
      type: Array,
      required: true,
    },
    settings: {
      type: Object,
      required: true,
    },
  },
};
</script>
